import React from 'react';
import { Info } from 'lucide-react';

export const LicenseDisclaimer: React.FC = () => {
  return (
    <div className="LicenseDisclaimer mt-8 border-t border-gray-200 pt-6">
      <div className="flex flex-col items-center gap-4 max-w-3xl mx-auto text-center">
        <div className="flex items-start gap-3 text-sm text-gray-600">
          <Info className="w-5 h-5 flex-shrink-0 mx-auto" />
          <p className="text-[14px] italic">
            This information is provided for discussion purposes only. All formal licensing should be presented on a Microsoft Customer Price Sheet (CPS). 
            For the most current Microsoft licensing terms and conditions, please visit{' '}
            <a 
              href="https://microsoft.com/licensing" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              microsoft.com/licensing
            </a>
          </p>
        </div>
        
        <p className="text-[14px] italic text-gray-600">
          Important: Microsoft Teams is sold as a separate suite SKU for Enterprise, Frontline, Business, and Office 365 plans. Prices shown use Microsoft&apos;s official with-Teams and no-Teams commercial list prices.
        </p>

        <p className="text-[14px] italic text-gray-600">
          Microsoft 365 E7 (Frontier Suite) is generally available — the first new enterprise tier since E5. It includes Copilot, Agent 365, Entra Suite, and Work IQ at $90.45/user/month without Teams or $99/user/month with Teams.
        </p>

        <p className="text-[14px] italic text-gray-600">
          Microsoft 365 Business Standard with Copilot and Business Premium with Copilot are permanent suite SKUs. Both are available with or without Teams; temporary Copilot Business promotional pricing is not shown.
        </p>

        <p className="text-[14px] italic text-gray-600">
          Summer 2026 packaging additions (Defender for Office Plan 1 on E3, Intune Plan 2 / Remote Help / Advanced Analytics, Security Copilot on E5, +50 GB business email, Copilot Chat enhancements) began rolling out in June 2026 and complete by August 1, 2026.
        </p>

        <p className="text-[14px] italic text-gray-600">
          Note: GCC customers are exempt from Teams unbundling - Teams continues to be included in all GCC plans at no additional cost.
        </p>

        <p className="text-[14px] italic text-gray-600">
          Pricing verified as of August 2026. Prices shown are for annual commitment with monthly billing (USD commercial list).
        </p>
        
        <p className="text-[14px] italic text-gray-600">
          This information created by{' '}
          <a 
            href="https://www.onpointhq.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 underline"
          >
            Celebration OnPoint
          </a>
          , a Microsoft partner. Let us help you align your licensing for your needs.
        </p>
      </div>
    </div>
  );
};
